// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__bfIGc","approved":"Status_approved__1oH9W","rejected":"Status_rejected__CSANz","expired":"Status_expired__31qPf","label":"Status_label__3YylW"};